import { lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { TICKET_PATH } from '@/components/TicketsModule/consts';
import { CONTACTS_PATH } from '@/components/ContactsV2/consts';

const HomeModule = lazy(() => import('./modules/home'));
const AuthModule = lazy(() => import('./modules/auth'));
const UsersModule = lazy(() => import('./modules/users'));
const GroupsModule = lazy(() => import('./modules/groups'));
const GroupsModuleV2 = lazy(() => import('./modules/groupsModule'));
const CompaniesModule = lazy(() => import('./modules/companies'));
const TagsModule = lazy(() => import('./modules/tags'));
const TypesModule = lazy(() => import('./modules/types'));
const RolsModule = lazy(() => import('./modules/roles'));
const ReportsModule = lazy(() => import('./modules/reports'));
const TicketsModule = lazy(() => import('./modules/tickets'));
const ProfileModule = lazy(() => import('./modules/profile'));
const ContactsModule = lazy(() => import('./modules/contacts'));
const ContactsModuleV2 = lazy(() => import('./modules/contactsv2'));
const BotsModule = lazy(() => import('./modules/bots'));
const ChannelsModule = lazy(() => import('./modules/channel'));
const NotificationsModule = lazy(() => import('./modules/notifications'));
const CustomFieldsModule = lazy(() => import('./modules/customFields'));
const TemplatesModule = lazy(() => import('./modules/templates'));
const ToolModule = lazy(() => import('./modules/tools'));
const RecordModule = lazy(() => import('./modules/records'));
const IaTesterModule = lazy(() => import('./modules/ia-tester'));
const TableTestModule = lazy(() => import('./modules/tableTest'));
const UsersTrackingModule = lazy(() => import('./modules/usersTracking'));
const TicketsModuleV2 = lazy(() => import('./modules/ticketsModule'));
//const ChatbotModule = lazy(() => import('./modules/chatbot'));
// const SupportsModule = lazy(()=> import("./modules/supports"))
// const ChannelsModule = lazy(()=> import("./modules/channels"))
// const TicketsModule = lazy(()=> import("./modules/tickets"))
// const PollsModule = lazy(()=> import("./modules/polls"))
// const PlansModule = lazy(()=> import("./modules/plans"))
// const ReportModule = lazy(()=> import("./modules/reports"))
// const HelpModule = lazy(()=> import("./modules/help"))
// const ReviewModule = lazy(()=> import("./modules/review"))
//
// const NotFound = lazy(()=> import("./modules/404"))
// const Forbidden = lazy(()=> import("./modules/403"))

function App() {
    return (
        <Routes>
            <Route path="/" element={<HomeModule />} />
            <Route index element={<Navigate to={'tickets/'} />} />
            <Route path="auth/*" element={<AuthModule />} />
            <Route path="users/*" element={<UsersModule />} />
            <Route path="groups/*" element={<GroupsModule />} />
            <Route path="groups_v2/*" element={<GroupsModuleV2 />} />
            <Route path="companies/*" element={<CompaniesModule />} />
            <Route path="tags/*" element={<TagsModule />} />
            <Route path="types/*" element={<TypesModule />} />
            <Route path="roles/*" element={<RolsModule />} />
            <Route path="reports/*" element={<ReportsModule />} />
            <Route path="tickets/*" element={<TicketsModule />} />
            <Route path={`${TICKET_PATH}/*`} element={<TicketsModuleV2 />} />
            <Route path="contacts_old/*" element={<ContactsModule />} />
            <Route path={`${CONTACTS_PATH}/*`} element={<ContactsModuleV2 />} />
            <Route path="bots/*" element={<BotsModule />} />
            <Route path="channels/*" element={<ChannelsModule />} />
            <Route path="notifications/*" element={<NotificationsModule />} />
            <Route path="customFields/*" element={<CustomFieldsModule />} />
            <Route path="templates/*" element={<TemplatesModule />} />
            <Route path="profile/*" element={<ProfileModule />} />
            <Route path="tools/*" element={<ToolModule />} />
            <Route path="records/*" element={<RecordModule />} />
            <Route path="ia-tester/*" element={<IaTesterModule />} />
            <Route path="table-test" element={<TableTestModule />} />
            <Route path="users-tracking/*" element={<UsersTrackingModule />} />
            {/*<Route  path="403/*" element={<Forbidden />} />*/}
            {/*<Route path="*" element={<NotFound />} />*/}
        </Routes>
    );
}

export default App;
//<Route path="chatbot/*" element={<ChatbotModule />} />
